import { createSlice } from '@reduxjs/toolkit';

export const ContactDB = createSlice({
    name: 'contact',
    initialState: {
        isSignedIn: false,
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        cognitoId: '',
        verify: false,
        apiUrl: '',
        loading: false,
        slideshow: false,
        register: {
            dealerName: '',
            dealerType: '',
            dealerAddress: '',
            dealerZipCode: '',
            dealerState: '',
            dealerCity: '',
            firstName: '',
            lastName: '',
            email: '',
            phone_number: '',
            phone: '',
        },
        contactus: {
            firstName: '',
            lastName: '',
            email: '',
            phone_number: '',
            phone: '',
            comments: ""
        }
    },
    reducers: {
        setSlideShow: (state, action) =>{
            return {
                ...state,
                slideShow: action.payload
            }
        },
        setLoading: (state, action) => {
            return{
                ...state,
                loading:action.payload
            }
            
        },
        signIn: (state, action) =>{
            return {
                ...state,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                email: action.payload.email,
                phone: action.payload.phone,
                cognitoId: action.payload.cognitoId,
                verify: action.payload.verify
            }
        },
        setAppValues: (state, action) => {
            var apiUrl = `${action.payload.api.apiUrl}${action.payload.dataSet}/listings?access_token=${action.payload.api.browserToken}&`;
            return {
                ...state,
                api:action.payload.api,
                dataSet:action.payload.dataSet,
                stage:action.payload.stage,
                apiUrl: apiUrl
            }
        },
        setContactRegister: (state, action) =>{
            var register = {
                ...state.register,
                ...action.payload
            }
            return {
                ...state,
                register: register
            }
        },
        setContactus: (state, action) =>{
            var contactus = {
                ...state.contactus,
                ...action.payload
            }
            return {
                ...state,
                contactus: contactus
            }
        }
    }
})

export const { signIn, setContactRegister, setAppValues, setLoading, setSlideShow, setContactus } = ContactDB.actions

export default ContactDB.reducer
